// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClickController from "./click_controller"
application.register("click", ClickController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NoticeController from "./notice_controller"
application.register("notice", NoticeController)
